import api from './api';
import router from '../../router';
import { debounce } from 'lodash';

//Path Regex to check if socket listener should be used
const pathRegex = /^\/statisticsOverview/;
const planningPathRegex = /^\/planning/;
const solutionPathRegex = /^\/solution/;

const mapStatisticsByUser = (statistics) => {
	const newStats = {};
	for (const statistic of statistics) {
		newStats[statistic.user] = statistic;
	}
	return newStats;
};

const state = {
	error: null,
	lastStatistics: {},
	statistics: {},
	updateStatistics: 0,
};

const getters = {
	isActiveOnDate: (state) => (user, dateString) => {
		const date = new Date(dateString);
		date.setUTCHours(0, 0, 0, 0);
		const dateOfEntry = user.dateOfEntry ? new Date(user.dateOfEntry) : null;
		const dateOfLeaving = user.dateOfLeaving ? new Date(user.dateOfLeaving) : null;
		return !((dateOfEntry && dateOfEntry > date) || (dateOfLeaving && dateOfLeaving < date));
	},
};

const mutations = {
	setError(state, { error }) {
		state.error = error;
	},

	setLastStatistics(state, statistics) {
		state.lastStatistics = mapStatisticsByUser(statistics);
	},

	setStatistics(state, statistics) {
		state.statistics = mapStatisticsByUser(statistics);
	},

	setUpdateStatistics(state) {
		state.updateStatistics = state.updateStatistics + 1;
	},
};

const actions = {
	async loadLastStatistics({ commit }, year) {
		const result = await api.getLastStatistics(year);
		if (result.data) {
			commit('setLastStatistics', result.data);
		}
	},

	async loadStatistics({ commit }, { date, users }) {
		const result = await api.getStatistics(date, users);
		commit('setStatistics', result.data);
	},

	// Socket event listeners
	async socket_loadStatistics({ state, commit, dispatch }, payload) {
		const currentPath = router.currentRoute.value.path;
		if (!pathRegex.test(currentPath) && !planningPathRegex.test(currentPath) && !solutionPathRegex.test(currentPath)) {
			return;
		}
		commit('setUpdateStatistics');
	},

	async socket_updatedStatistics({ state, commit, dispatch }, payload) {
		if (
			!pathRegex.test(router.currentRoute.path) &&
			!planningPathRegex.test(router.currentRoute.path) &&
			!solutionPathRegex.test(router.currentRoute.path)
		) {
			return;
		}
		debouncedCommitUpdateStatistics(commit);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
